module.exports = __webpack_public_path__ + "static/media/globe.6b6393e2.png";